<div (click)="open($event)" class="button" [style.display]="figure.errors && figure.errors.length > 0 ? '' : 'none'">
  @if (!!figure.errors && figure.errors.length > 0) {
  <a>
    <img class="ghs-svg" src="./assets/images/warning.svg">
  </a>
  }
</div>